const siccij = {
  IniciarSesion: 'SICCIJ/ValidaYObtenPermisos',
  ConsultaDeCitasRecepcion: "SICCIJ/ConsultaDeCitasRecepcion",
  GetCita: "SICCIJ/GetCita",
  ActualizarEstatusExpedientes: "SICCIJ/ActualizarEstatusExpedientes",
  RevisarEstatusExpedientesCita: "SICCIJ/RevisarEstatusExpedientesCita",
  GenerarTextoCorreoAvisoSolicitanteDeCita: "SICCIJ/GenerarTextoCorreoAvisoSolicitanteDeCita",
  GetCitas: "SICCIJ/GetCitas",
  MarcarCitaAtendida: "SICCIJ/MarcarCitaAtendida",
  GetBloquesAgendaHoy: "SICCIJ/GetBloquesAgendaHoy",
  GetAreaIdUsuario: "SICCIJ/GetAreaIdUsuario",
  AgregarTramiteSinCita: "SICCIJ/AgregarTramiteSinCita",
  ObtenerEstadisticasAtencionCitas: "SICCIJ/ObtenerEstadisticasAtencionCitas",
  EnviarCorreoSolicitante: "SICCIJ/EnviarCorreoSolicitante",
  LlenarAgendaBloques: "SICCIJ/LlenarAgendaBloques",
  MarcarCitaNotificada: "SICCIJ/MarcarCitaNotificada",
  RevisarCitasRezagadas: "SICCIJ/RevisarCitasRezagadas",
  GetInformacionNotificacionCita: "SICCIJ/GetInformacionNotificacionCita",
  RegresarExpedientes: "SICCIJ/RegresarExpedientes",
  ReagendarExpedientes: "SICCIJ/ReagendarExpedientes",
  MostrarAgendaBloqueos: "SICCIJ/MostrarAgendaBloqueos",
  BloquearEspacios: "SICCIJ/BloquearEspacios"
}
export default siccij;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICCIJ/funcion/siccij.js
// module id = null
// module chunks = 